import Toast from "../../base/components/Toast";

// Stripe PaymentIntent statuses the funds flows branch on.
export const PaymentIntentStatus = Object.freeze({
   SUCCEEDED: "succeeded",
   PROCESSING: "processing",
   REQUIRES_ACTION: "requires_action",
   REQUIRES_PAYMENT_METHOD: "requires_payment_method"
});

export const PAYMENT_MESSAGES = Object.freeze({
   success: "Funds added successfully!",
   processing: "Payment is processing. Funds will be added shortly.",
   pendingConfirm: "Payment received. Funds will be added shortly.",
   declined: "Your card was declined. Please use a different card.",
   failed: "Payment could not be completed. Please try again."
});

// Shows the toast for a recognized non-succeeded PaymentIntent status, shared
// by both the saved-card purchase and the post-redirect 3DS resume. Returns
// true when the status was recognized (and a toast shown), false otherwise.
//
// The succeeded case and the "unknown status" fallback are intentionally left
// to callers: each success path does different work (confirm the payment,
// refresh the page), and only the active purchase flow wants a generic "failed"
// toast on an unrecognized status — the silent redirect-resume does not.
export const notifyNonSuccessStatus = (status) => {
   switch (status) {
      case PaymentIntentStatus.PROCESSING:
         Toast.success(PAYMENT_MESSAGES.processing);
         return true;
      case PaymentIntentStatus.REQUIRES_PAYMENT_METHOD:
         Toast.warning(PAYMENT_MESSAGES.declined);
         return true;
      default:
         return false;
   }
};
